(function MainProduct() {
  /**
   * Variant Selection scripts
   * ------------------------------------------------------------------------------
   *
   * Handles change events from the variant inputs in any `cart/add` forms that may
   * exist. Also updates the master select and triggers updates when the variants
   * price or image changes.
   *
   * @namespace variants
  */

  const Variants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = slate.utils.compact(currentOptions);

        return currentOptions;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.product.variants;
        var found = false;

        variants.forEach(function(variant) {
          var satisfied = true;

          selectedValues.forEach(function(option) {
            if (satisfied) {
              satisfied = (option.value === variant[option.index]);
            }
          });

          if (satisfied) {
            found = variant;
          }
        });

        return found || null;
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param {object} variant - Currently selected variant
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param {object} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container)[0].value = variant.id;
      }
    });

    return Variants;
  })();

  /**
   * Product Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Product template.
   *
     * @namespace product
   */

  const Product = (function() {
    var selectors = {
      addToCart: '[data-add-to-cart-main]',
      addToCartText: '[data-add-to-cart-text]',
      comparePrice: '[data-compare-price]',
      comparePriceText: '[data-compare-text]',
      savePrice: '[data-save-price]',
      originalSelectorId: '[data-product-select]',
      priceWrapper: '[data-price-wrapper]',
      productForm: '[data-product-form]',
      productFeaturedImage: '[data-product-featured-image] img',
      productJson: '[data-product-json]',
      productPrice: '[data-product-price]',
      productThumbs: '[data-product-single-thumbnail]',
      productAvailable: '[data-product-available]',
      productShippingEstimate: '[data-shipping-estimate]',
      singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
      this.$container = $(container);

      // Stop parsing if we don't have the product json script tag when loading
      // section in the Theme Editor
      if (!$(selectors.productJson, this.$container).html()) return;

      var sectionId = this.$container.attr('data-section-id');
      this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.settings = {};
      this.namespace = '.product';
      this.variants = new Variants(options);
      this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantChange' + this.namespace, this.updateProductColor.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
      this.$container.on('variantChange' + this.namespace, this.updatePreorder.bind(this));
    }

    Product.prototype = $.extend({}, Product.prototype, {

      /**
       * Updates the DOM state of the add to cart button
       *
       * @param {boolean} enabled - Decides whether cart is enabled or disabled
       * @param {string} text - Updates the text notification content of the cart
       */
      updateAddToCartState: function(evt) {
        var variant = evt.variant;
        
        POV.emit('variant:change_hotfix', variant);

        if (variant) {
          POV.emit('variant:change', variant);
          
          $(selectors.priceWrapper, this.$container).removeClass('hide');
          $(selectors.productForm, this.$container).removeClass('variant-unavailable');

          if (variant.featured_media) {
            if (typeof POV.Gallery === 'object') { 
              POV.Gallery.goToId(variant.featured_media.id);
            }
          }

        } else {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(POV.Liquid.lang.unavailable);
          $(selectors.productAvailable).attr('data-product-available', 'false');
          $(selectors.productForm, this.$container).addClass('variant-unavailable');
          return;
        }

        if (variant.available) {
          $(selectors.addToCart, this.$container).prop('disabled', false);
          $(selectors.addToCartText, this.$container).html(POV.Liquid.lang.addToCart);
          $(selectors.productAvailable).attr('data-product-available', 'true');
        } else {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(POV.Liquid.lang.soldOut);
          $(selectors.productAvailable).attr('data-product-available', 'false');
        }
      },

      /**
       * Updates the DOM with specified prices
       *
       * @param {string} productPrice - The current price of the product
       * @param {string} comparePrice - The original price of the product
       */
      updateProductPrices: function(evt) {
        var variant = evt.variant;
        var $comparePrice = $(selectors.comparePrice, this.$container);
        var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
        var $savePrice = $(selectors.savePrice, this.$container);
        
        if (!variant) return;

        $(selectors.productPrice, this.$container)
          .html(POV.Currency.formatMoney(variant.price, POV.Liquid.moneyFormat))
          .attr('data-product-price', variant.price);

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(POV.Currency.formatMoney(variant.compare_at_price, POV.Liquid.moneyFormat));
          $comparePrice.attr('data-compare-price', variant.compare_at_price);
          $compareEls.removeClass('hide');

          var delta = variant.compare_at_price - variant.price;
          $savePrice.html(POV.Liquid.lang.saveText + POV.Currency.formatMoney(delta, POV.Liquid.moneyFormat));
          $savePrice.removeClass('hide');
        } else {
          $comparePrice.html('');
          $comparePrice.attr('data-compare-price', '');
          $compareEls.addClass('hide');
          $savePrice.addClass('hide');
        }
      },
      
      /**
       * Updates the DOM with selected color
       */
      updateProductColor: function(evt) {
        var variant = evt.variant;
        
        if (!variant) {
          var $colorSelected = $('input[name="colour-swatch"]:checked')
          if ($colorSelected.length) {
            $('[data-js-color]').text($colorSelected.attr('data-value'));
          }
          return;
        }
        
        var options = this.productSingleObject.options;
        var colorIndex = options.indexOf('Color');
        
        if (colorIndex !== -1) {
          $('[data-js-color]').text(variant.options[colorIndex]);
        }
      },
      
      updatePreorder: function(evt) {
        var variant = evt.variant;
        Preorder(variant);
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      }
    });

    return Product;
  })();

  const Preorder = (function(variant) {
    var $config = $('[data-preorder]');
    if (!$config.length || !variant) return;
    
    var config = JSON.parse($config.html());
    var variantConfig = config[String(variant.id)];
    var $wrap = $('[data-section-type="product"]');
    var $msg = $('[data-preorder-msg]');
    var $date = $('[data-preorder-date]');
    var $atc = $('[data-add-to-cart-text]');
    
    if (variantConfig && variantConfig.msg && variantConfig.inventory_policy === 'continue' && variantConfig.inventory_quantity <= 0) {
      $wrap.addClass('pre-order');
      $date.text(variantConfig.msg);
      $msg.removeAttr('hidden');
      $atc.text(POV.Liquid.lang.preOrder);
    } else {
      $msg.attr('hidden', true);
      $wrap.removeClass('pre-order');
      $atc.text(POV.Liquid.lang.addToCart);
    }
  });

  (function() {
    var $init = $('[data-preorder-variant]');
    if (!$init.length) return;
    
    Preorder(JSON.parse($init.html()))
  })();

  document.addEventListener('DOMContentLoaded', () => {
    POV.Product = new Product('[data-section-type="product"]'); 
  });
})();

(function BuyBar(){
  if (!POV.support.IntersectionObserver) return;
  
  var target = document.querySelector('[data-buy-bar-target-trigger]');
  var bar = document.querySelector('[data-buy-bar]');
  var $barBtn = $('[data-buy-bar] [data-buy-btn]');
  var $atcBtn = $('[data-add-to-cart-main]');

  if (!target || !bar) return;

  $(document).on('variantChange.product', function(evt) {
    var variant = evt.variant;
    var variantAvailable = Boolean(variant && variant.available);
    bar.setAttribute('data-buy-bar-available', variantAvailable);
  })

  function callback(entries){
    var isVisible = entries[0].boundingClientRect.y < entries[0].rootBounds.top;
    isVisible
      ? bar.removeAttribute('data-buy-bar-hidden') 
      : bar.setAttribute('data-buy-bar-hidden', true);
    isVisible
      ? document.body.classList.add('buy-bar-visible')
      : document.body.classList.remove('buy-bar-visible');
  }

  $barBtn.on('click', function(){
    $atcBtn.trigger('click');
  });
  
  var observer = new IntersectionObserver(callback, {
    rootMargin: "-25% 0px -25% 0px",
    threshold: 1
  });

  observer.observe(target);
})(); 

(function ProductReviewBadge(){
  var reviewBadge = document.querySelector('[data-review-badge]');
  if (!reviewBadge) return;

  document.addEventListener('stamped:reviews:loaded', function(e) {
    var minCount = Number(reviewBadge.getAttribute('data-review-badge-min-count'));
    var fiveStarCount = Number($('[data-rating="5"]').parent('[data-count]').attr('data-count'));
    var reviewBadgeCount = reviewBadge.querySelector('[data-review-badge-count]');

    if (!reviewBadgeCount) return;

    if (fiveStarCount >= minCount) {
      reviewBadgeCount.textContent = Math.floor(fiveStarCount/10) * 10;
      reviewBadge.removeAttribute('hidden');
    }
  });
})();

(function SwatchChange() {
  // On product swatch click, update the product variant selector
  document.querySelectorAll('.product-swatches input').forEach(function(swatch) {
    swatch.addEventListener('change', function(evt) {
      var value = swatch.getAttribute('data-value');
      var option = swatch.getAttribute('data-option');

      var selector = '[data-single-option-selector][data-index="option' + option + '"]';
      var productSingleOptionSelectorElement = document.querySelector(selector);
      
      if (productSingleOptionSelectorElement) {
        productSingleOptionSelectorElement.value = value;

        // Create and dispatch a change event
        var changeEvent = new Event('change', { bubbles: true });
        productSingleOptionSelectorElement.dispatchEvent(changeEvent);
      }
    });
  });
})();